var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{ref:"redirector",attrs:{"href":_vm.url},on:{"click":function($event){_vm.clicked($event)},"focusout":function($event){_vm.focusout($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }